// https://vuex.vuejs.org/en/state.html

export default {
  authStatus: "",
  token: localStorage.getItem("token") || "",
  user: localStorage.getItem("user") || { name : null, designation: null },
  role: localStorage.getItem("role") || "",
  usermenu: localStorage.getItem("usermenu"),
  settings: localStorage.getItem("settings"),
  datetype: localStorage.getItem("datetype"),
  company: localStorage.getItem("company"),
  inboxcount: localStorage.getItem("inboxcount"),
  pagetitle: "",
  tableList: [],
  snackbar: {
    show: false,
    color: "general",
    message: "",
  },
  locales: [
    { locale: "en", title: "English", icon: require("@/assets/img/en.png") },
    { locale: "ne", title: "Nepali", icon: require("@/assets/img/ne.png") },
  ],
  dateTypes: [{ id: "AD", title: "English" }, { id: "BS", title: "Nepali" }],
  message: null
};
